"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/product.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Fproduct.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
const lending_eligibility_1 = require("../common/lending-eligibility");
const product_status_1 = require("./product-status");
const product_type_1 = require("./product-type");
const protobufPackage = 'com.step.underwriting.common.proto';
function createBaseProduct() {
    return {
        type: product_type_1.ProductType.INVALID_PRODUCT_TYPE,
        status: product_status_1.ProductStatus.INVALID_PRODUCT_STATUS,
        eligibility: undefined,
    };
}
exports.Product = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = (0, product_type_1.productTypeFromJSON)(object.type);
        }
        if (isSet(object.status)) {
            message.status = (0, product_status_1.productStatusFromJSON)(object.status);
        }
        if (isSet(object.eligibility)) {
            message.eligibility = lending_eligibility_1.LendingEligibility.fromJSON(object.eligibility);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined && message.type !== product_type_1.ProductType.INVALID_PRODUCT_TYPE) {
            obj.type = (0, product_type_1.productTypeToJSON)(message.type);
        }
        if (message.status !== undefined && message.status !== product_status_1.ProductStatus.INVALID_PRODUCT_STATUS) {
            obj.status = (0, product_status_1.productStatusToJSON)(message.status);
        }
        if (message.eligibility !== undefined) {
            obj.eligibility = lending_eligibility_1.LendingEligibility.toJSON(message.eligibility);
        }
        return obj;
    },
    create(base) {
        return exports.Product.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProduct();
        message.type = object.type ?? product_type_1.ProductType.INVALID_PRODUCT_TYPE;
        message.status = object.status ?? product_status_1.ProductStatus.INVALID_PRODUCT_STATUS;
        message.eligibility = (object.eligibility !== undefined && object.eligibility !== null)
            ? lending_eligibility_1.LendingEligibility.fromPartial(object.eligibility)
            : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=product.js.map